import React from 'react';
import {CheckCircleIcon, MinusCircleIcon, XCircleIcon} from "@heroicons/react/outline";

// Types ----

type TernaryIndicatorProps = {
  value: boolean | null
}

// Component ----

function TernaryIndicator({value}: TernaryIndicatorProps) {

  if (value === null) {
    return <MinusCircleIcon className="h-5 w-5 text-gray-600 inline align-bottom"/>
  }

  if(value) {
    return <CheckCircleIcon className="h-5 w-5 text-green-600 inline align-bottom"/>
  }

  return <XCircleIcon className="h-5 w-5 text-red-600 inline align-bottom"/>
}

// Export ----

export default TernaryIndicator;